import Gizmo from '../gizmo';
import RootGizmo from '../root-gizmo';
import SectionStateMachine from '../section-state-machine';

interface IParams {
  gizmo: RootGizmo | Gizmo;
  stateMachine?: SectionStateMachine;
}

/**
 * Get gizmos to render on the screen, in SHOW mode. Right now what this function does is flattens
 * the tree. After running this function we still have to filter the section and the added button
 * gizmos.
 *
 * @param {RootGizmo | Gizmo} gizmo gizmo from which we're extracting gizmos to render on the screen
 * @returns
 */
function getShowScreenGizmos({
  gizmo,
  stateMachine,
}: IParams): (Gizmo | RootGizmo)[] | undefined {
  const childGizmos = gizmo.getGizmos();
  let screenGizmos = gizmo.getGizmos();

  if (childGizmos && childGizmos.length > 0 && stateMachine) {
    const sectionGizmos = childGizmos.filter(
      gizmo => gizmo.getConfig().type === 'section'
    );

    for (const sectionGizmo of sectionGizmos) {
      const sectionState = stateMachine
        .getStates()
        ?.find(s => s.sectionFid === sectionGizmo.getConfig().fid);

      if (sectionState?.display === true) {
        const sectionChildGizmos = getShowScreenGizmos({
          gizmo: sectionGizmo,
          stateMachine,
        });

        if (
          screenGizmos &&
          sectionChildGizmos &&
          sectionChildGizmos.length > 0
        ) {
          screenGizmos = screenGizmos.concat(sectionChildGizmos);
        }
      }
    }
  }

  return screenGizmos;
}

export default getShowScreenGizmos;
